<template>
  <card :title="title" class="d-flex flex-column">
    <p class="card-description">{{ description }}</p>
    <div class="download-row">
      <button
        class="btn btn-sm btn-info download-button"
        :disabled="isDownloading"
        :title="`Download ${title} as CSV`"
        @click="download">
        <span v-if="isDownloading" class="spinner-border small-spinner" role="status">
          <span class="sr-only">Downloading...</span>
        </span>
        <font-awesome-icon v-else icon="download" />
        Download
      </button>
    </div>
  </card>
</template>

<script>
import Card from './Card.vue';
import api from '@/services/api';
import { notify } from '@/services/notify';
import moment from 'moment';

const FILENAME_PATTERN = /filename="?([^"]+)"?/;

export default {
  name: "ReportCard",
  components: {
    Card
  },
  props: {
    title: String,
    description: String,
    // report endpoint path, e.g. "/reports/active-user-emails"
    url: String,
    fileStem: String
  },
  data() {
    return {
      isDownloading: false
    };
  },
  methods: {
    async download() {
      if (this.isDownloading) {
        return;
      }
      this.isDownloading = true;

      try {
        const response = await api.getFile(this.url);
        this.saveFile(response.data, this.fileName(response));
      }
      catch (error) {
        notify().error(`Failed to download ${this.title}.<br>${error}`);
      }
      finally {
        this.isDownloading = false;
      }
    },
    // Content-Disposition is only readable when the API exposes it via CORS,
    // so fall back to the same name the API builds.
    fileName(response) {
      const disposition = response.headers['content-disposition'];
      const match = disposition && disposition.match(FILENAME_PATTERN);
      if (match) {
        return match[1];
      }
      return `${this.fileStem}-${moment.utc().format('YYYYMMDD-HHmmss')}.csv`;
    },
    saveFile(blob, fileName) {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.card-description {
  margin-bottom: 0;
}

.card ::v-deep .card-body {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.download-row {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 15px;
}
.download-button {
  white-space: nowrap;
}

.download-button .small-spinner {
  color: #fff;
}
</style>
